import { render, staticRenderFns } from "./GoodColorSet.vue?vue&type=template&id=4c35b3bc"
import script from "./GoodColorSet.vue?vue&type=script&lang=js"
export * from "./GoodColorSet.vue?vue&type=script&lang=js"
import style0 from "./GoodColorSet.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports